import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { useQuery } from '@tanstack/react-query';

export const useFetchOrganisationList = () => {
  return useQuery<IOrganisation[], Error>({
    queryKey: ['organisationList'],
    queryFn: async () => {
      return await get(API_URLS.ORGANISATION_LIST);
    },
  });
};
